import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[appLeadOfferActionRejectIcon]',
    standalone: false
})
export class LeadOfferActionRejectIconDirective {

  @HostBinding('style') style = 'color: red; cursor: pointer; transform: scale(1.25);'
  @HostBinding('innerHTML') iconType = 'cancel'

  constructor() { }

}
